import { $cssValue } from './constants';
import { replaceTokens } from './replaceTokens';
export function createValue(tokenMap, value) {
    const result = replaceTokens(tokenMap, value);
    return {
        [$cssValue]: true,
        value: result,
        toString () {
            return result;
        }
    };
}
export function isCssValue(value) {
    return typeof value === 'object' && value != null && $cssValue in value;
}

//# sourceMappingURL=value.js.map